module.exports = __webpack_public_path__ + "img/011.abbb3b2f.jpg";